import { useState } from "react";
import { getConsent, setConsent } from "../lib/analytics";
import "./css/consent_banner.css";

export default function ConsentBanner() {
  const [decided, setDecided] = useState(() => getConsent() !== null);

  if (decided) return null;

  const decide = (value) => {
    setConsent(value);
    setDecided(true);
  };

  return (
    <div className="rl-consent" role="dialog" aria-label="Cookie consent">
      <p className="rl-consent-text">
        We use analytics cookies to understand how visitors use RemboList.
        See our <a href="#">Privacy Policy</a> for details.
      </p>
      <div className="rl-consent-actions">
        <button
          type="button"
          className="rl-consent-btn rl-consent-btn--decline"
          onClick={() => decide("denied")}
        >
          Decline
        </button>
        <button
          type="button"
          className="rl-consent-btn rl-consent-btn--accept"
          onClick={() => decide("granted")}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
